import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: true,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      refetchOnReconnect: false,
      networkMode: "always",
      staleTime: 1000,
      retry: false,
      structuralSharing: false,
    },
  },
})

export default function DataProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation()

  useEffect(() => {
    queryClient.invalidateQueries()
  }, [i18n.language])
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} position='top' /> */}
    </QueryClientProvider>
  )
}
